import { MarcaModel } from '@/store/catalogos/marcas';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogoMarcaService } from '@services/catalogo/catalogoMarca.service';
import { ValidatorsService } from '@services/util/validators.service';

@Component({
  selector: 'app-formulario-marca',
  templateUrl: './formulario-marca.component.html',
  styleUrls: ['./formulario-marca.component.scss']
})
export class FormularioMarcaComponent {
form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nueva Marca";


  constructor(
    private util: Util,
    private catalogoService: CatalogoMarcaService,
    public dialogRef: MatDialogRef<FormularioMarcaComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Marca";
    }
    if (data.view) {
      this.title = "Vista Marca";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);

  }

  private buildForm(data: MarcaModel): void {
    this.form = new FormGroup({
      idMarca: new FormControl(data?.idMarca ?? null),
      marca: new FormControl(data?.marca ?? '', {
        validators: [Validators.required, Validators.maxLength(50)]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }

 
  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const marca: MarcaModel = this.formToModel();
    const request = this.data.insert

      ? this.catalogoService.create(marca)
      : this.catalogoService.update(marca);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): MarcaModel {
    const formValues = this.form.getRawValue();

    return {
      idMarca: formValues.idMarca ?? '',
      marca: formValues.marca ?? ''
    };
  }
}
